// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"9f05c4c2","396":"9534d45c","455":"6e6b3086","977":"0216a576"}[chunkId] + ".chunk.js";
};